import { IconButton } from '@material-ui/core';
import { KeyboardArrowUp } from '@material-ui/icons';
import useStyles from './style';
import { IAccordionEquipmentGridProps, IStyleProps } from './types';

const AccordionEquipmentGrid = ({
  description,
  actionButtons,
  children,
  maxHeight,
  toggleButton,
  setToggleButton,
}: IAccordionEquipmentGridProps & IStyleProps) => {
  const classes = useStyles({ maxHeight } as IStyleProps);

  const toggleAccordion = () => {
    setToggleButton(!toggleButton);
  };

  const applyOpenStyles = () =>
    toggleButton ? classes.accordionOpen : classes.accordionClosed;

  const applyButtonOpenStyles = () =>
    toggleButton
      ? classes.toggleButton
      : [classes.toggleButton, classes.toggleButtonClosed].join(' ');

  return (
    <div className={classes.accordionWrapper}>
      <div className={classes.accordionTitle}>
        <div className={classes.description}>{description}</div>
        <div className={classes.accordionTitleItens}>
          <div className={classes.actionButtons}>{actionButtons}</div>
          <div className={applyButtonOpenStyles()}>
            <IconButton
              size="small"
              component="span"
              onClick={toggleAccordion}
              data-testid="icon-open"
            >
              <KeyboardArrowUp />
            </IconButton>
          </div>
        </div>
      </div>
      <div className={applyOpenStyles()}>
        <div className={classes.accordionBody}>{children}</div>
      </div>
    </div>
  );
};

export default AccordionEquipmentGrid;
